import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { reducer as toastrReducer } from 'react-redux-toastr';

import AuthReducer from '../auth/authReducer';
import TextoReducer from '../texto/textoReducer';
import DashboardReducer from '../dashboard/dashboardReducer';
import TabReducer from '../common/tab/tabReducer';
import UsuarioReducer from '../usuario/usuarioReducer';
import IdeiaNegocioReducer from '../ideiaNegocio/ideiaNegocioReducer';
import DicionarioReducer from '../dicionario/dicionarioReducer';
import ParceiroReducer from '../parceiro/parceiroReducer';
import StartupReducer from '../startup/startupReducer';
import EventoReducer from '../evento/eventoReducer';
import MentorReducer from '../mentor/mentorReducer';
import TrilhaConhecimentoReducer from '../trilhaConhecimento/trilhaConhecimentoReducer';
import PreIncubacaoIdeacaoReducer from '../preIncubacaoIdeacao/preIncubacaoIdeacaoReducer';
import PreIncubacaoPrototipoReducer from '../preIncubacaoPrototipo/preIncubacaoPrototipoReducer';
import PreIncubacaoValidacaoReducer from '../preIncubacaoValidacao/preIncubacaoValidacaoReducer';
import PreIncubacaoPitchReducer from '../preIncubacaoPitch/preIncubacaoPitchReducer';
import VideoReducer from '../video/videoReducer';
import IncubacaoSelecaoReducer from '../incubacaoSelecao/incubacaoSelecaoReducer';
import IncubacaoReducer from '../incubacao/incubacaoReducer';
import IncubacaoPlanejamentoReducer from '../incubacaoPlanejamento/incubacaoPlanejamentoReducer';
import IncubacaoMetaReducer from '../incubacaoMeta/incubacaoMetaReducer';
import IncubacaoConsultoriaReducer from '../incubacaoConsultoria/incubacaoConsultoriaReducer';
import IncubacaoMaturidadeAno1Reducer from '../incubacaoMaturidadeAno1/incubacaoMaturidadeAno1Reducer';
import IncubacaoMaturidadeAno2Reducer from '../incubacaoMaturidadeAno2/incubacaoMaturidadeAno2Reducer';
import IncubacaoMaturidadeAno3Reducer from '../incubacaoMaturidadeAno3/incubacaoMaturidadeAno3Reducer';
import OportunidadeReducer from '../oportunidade/oportunidadeReducer';
import IncubacaoAvaliacaoReducer from '../incubacaoAvaliacao/incubacaoAvaliacaoReducer';

const rootReducer = combineReducers({
	auth: AuthReducer,
	texto: TextoReducer,
	dashboard: DashboardReducer,
	usuario: UsuarioReducer,
	ideiaNegocio: IdeiaNegocioReducer,
	dicionario: DicionarioReducer,
	parceiro: ParceiroReducer,
	startup: StartupReducer,
	evento: EventoReducer,
	mentor: MentorReducer,
	trilhaConhecimento: TrilhaConhecimentoReducer,
	preIncubacaoIdeacao: PreIncubacaoIdeacaoReducer,
	preIncubacaoPrototipo: PreIncubacaoPrototipoReducer,
	preIncubacaoValidacao: PreIncubacaoValidacaoReducer,
	preIncubacaoPitch: PreIncubacaoPitchReducer,
	video: VideoReducer,
	incubacaoSelecao: IncubacaoSelecaoReducer,
	incubacao: IncubacaoReducer,
	incubacaoPlanejamento: IncubacaoPlanejamentoReducer,
	incubacaoMeta: IncubacaoMetaReducer,
	incubacaoConsultoria: IncubacaoConsultoriaReducer,
	incubacaoMaturidadeAno1: IncubacaoMaturidadeAno1Reducer,
	incubacaoMaturidadeAno2: IncubacaoMaturidadeAno2Reducer,
	incubacaoMaturidadeAno3: IncubacaoMaturidadeAno3Reducer,
	incubacaoAvaliacao: IncubacaoAvaliacaoReducer,
	oportunidade: OportunidadeReducer,
    tab: TabReducer,
    form: formReducer,
    toastr: toastrReducer
});

export default rootReducer;

